/*
 * Copyright (c) 2021. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import LandingPageTeaser from "../../../../../components/Teaser/LandingPageTeaser";
import Container from "../../../../../components/Container/Container";
import TrafficCheckin from "../../../../../components/Checkin/TrafficCheckin/TrafficCheckin";
import IncorrectPenaltySection from "../../../../../components/Sections/Traffic/IncorrectPenaltySection/IncorrectPenaltySection";
import AttorneySection from "../../../../../components/Sections/Generic/AttorneySection/AttorneySection";
import AdvantagesLegalbirdAttorneySection from "../../../../../components/Sections/Generic/AdvantagesLegalbirdAttorneySection/AdvantagesLegalbirdAttorneySection";
import TrustSection from "../../../../../components/Sections/Generic/TrustSection/TrustSection";
import TrafficCostRiskSection from "../../../../../components/Sections/Traffic/TrafficCostRiskSection/TrafficCostRiskSection";
import { getLastPathSplit } from "../../../../../services/redirect";
import { landingPagesList } from "../../../../../services/landingPagesList";
import LpSpeedingMeta from "./LpSpeedingMeta";
import Layout from "../../../../Layouts/Layout";
import PartnersSection from "../../../../../components/Sections/Generic/PartnersSection/PartnersSection";
import LinkedCardBox from "../../../../../components/LinkedCardBox/LinkedCardBox";
import { trafficTeaserCards } from "../../../../../services/landingPageService";
import GreyBackgroundWrapper from "../../../../../components/BackgroundWrapper/GreyBackgroundWrapper";
import { useLocation } from "react-router";
import { useCustomer } from "../../../../../provider/Customer/CustomerProvider";
import HowItWorksSectionTraffic
  from "../../../../../components/Sections/Traffic/HowItWorksSection/HowItWorksSectioTraffic";

const LpSpeeding = () => {
  const accusationData = {
    name: "speeding",
    detail: {
      name: "speeding.locality",
      label: "Wo waren Sie unterwegs?",
      options: [
        { value: "in_town", label: "Innerorts" },
        { value: "out_of_town", label: "Außerorts" },
        { value: "unknown", label: "Ich bin mir nicht sicher" },
      ],
    },
  };

  const location = useLocation();
  const lpKey = getLastPathSplit(location.pathname);
  const keyword = (lpKey && landingPagesList[lpKey]?.keyword) ?? "Überhöhte Geschwindigkeit Bußgeld";
  const headline = (lpKey && landingPagesList[lpKey]?.headline) ?? "Zu schnell gefahren?";
  const { isLoggedIn } = useCustomer();

  return (
    <Layout minimal={!isLoggedIn} clickableLogo={isLoggedIn} backgroundType={"landingpage"}>
      <LpSpeedingMeta keyword={keyword} />
      <LandingPageTeaser
        headline={headline}
        subheadline={"Jetzt effektiv gegen Bußgeld, Punkte oder Fahrverbot vorgehen!"}
        teaserButtonText={"Kostenlose Ersteinschätzung"}
        teaserButtonLink={isLoggedIn ? "/servicewelt" : "#top-checkin"}
      >
        <LinkedCardBox linkedCards={trafficTeaserCards} />
      </LandingPageTeaser>
      <GreyBackgroundWrapper>
        {!isLoggedIn && (
          <Container>
            <TrafficCheckin idPrefix={"top"} checkinHeading={"Wir geben Ihnen eine kostenlose Ersteinschätzung"} accusation={accusationData} />
          </Container>
        )}
        <IncorrectPenaltySection />
        <HowItWorksSectionTraffic />
      </GreyBackgroundWrapper>
      <TrafficCostRiskSection />
      <GreyBackgroundWrapper>
        <AttorneySection
          product={"traffic"}
          textCards={false}
          subheading={"Sie möchten professionell und unkompliziert gegen Ihren Bescheid vorgehen? Wir helfen Ihnen - jederzeit und ortsunabhängig!"}
        />
        <AdvantagesLegalbirdAttorneySection product={"traffic"} />
      </GreyBackgroundWrapper>
      <TrustSection />
      {!isLoggedIn && (
        <Container>
          <TrafficCheckin idPrefix={"bottom"} checkinHeading={"Wir geben Ihnen eine kostenlose Ersteinschätzung"} accusation={accusationData} />
        </Container>
      )}
      <PartnersSection />
    </Layout>
  );
};

export default LpSpeeding;
